import { useEffect, useRef, useState } from 'react';

const testimonials = [
  {
    name: 'Sophie Martin',
    role: 'Fondatrice, Lumière Wellness',
    text: 'Manova a transformé complètement mon image en ligne. Le site est magnifique, moderne et reflète parfaitement l\'esprit de mon entreprise. Je recommande à 100%.',
    rating: 5,
  },
  {
    name: 'Thomas Bernard',
    role: 'Directeur, Artisan Chocolat',
    text: 'Un travail remarquable du début à la fin. L\'écoute, la créativité et le professionnalisme sont au rendez-vous. Notre site e-commerce dépasse nos attentes.',
    rating: 5,
  },
  {
    name: 'Clara Dubois',
    role: 'Créatrice, Atelier Flora',
    text: 'Enfin une agence qui comprend vraiment ce que je veux ! Le design est élégant, féminin et exactement dans l\'ambiance que je souhaitais. Merci infiniment.',
    rating: 5,
  },
];

export default function Testimonials() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return null;
}
